export enum FontSize {
  large = '24px',
  big = '20px',
  medium = '16px',
  subMedium = '14px',
  small = '12px',
  subLarge = '20px'
};
